<template>
  <!-- v1 -->
  <div
    @mouseover="hover = true"
    @mouseleave="hover = false"
    style="width:100%;height:100%;margin:0px;padding:0px;z-index:100"
  >
    <el-link
      @click.stop="stopclick"
      v-if="islink&&alterClickable&&hover"
      :href="islink"
      class="hover-redirect"
    >
      <i class="material-icons">launch</i>
    </el-link>
    <!-- <el-button
      v-if="!islink&&alterClickable&&hover"
      @click.stop="handleAlter"
      class="hover-redirect"
      type="text"
    >
      <i class="material-icons">launch</i>
    </el-button>-->

    <slot v-if!="type"></slot>
    <span>{{parsedVal}}</span>
  </div>
</template>

<script>
import * as moment from "moment";

export default {
  name: "s-cell",

  props: {
    islink: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    value: { default: null },
    colprops: {
      default: null
    }
  },
  data() {
    return { hover: false, alterClickable: false };
  },
  computed: {
    parsedVal() {
      var out = this.value;
      // _log_("CCC..", this.type);
      if (this.type == "date") out = moment.unix(out).format("DD/MM/YYYY");
      return out;
    }
  },
  methods: {
    stopclick(e) {
        _log_("CCC alter..", e);
      e.preventDefault();
      e.stopPropagation();
    },
    handleAlter(e) {
    
      this.$emit("execute", { alterClick: true, ...e });
    },
    displayVal(v) {
      var out = v;
      // _log_("chll..clk...", this.type);
      if (this.type == "date") out = format(new Date(v * 1000), "DD/MM/YYYY");
      return out;
    }
  },
  created() {
    // _log_("chll..clk...", this.colprops);
    this.alterClickable = this.colprops ? this.colprops.alterClickable : false;
  }
};
</script>
<style >
.hover-redirect {
  z-index: 20;
  position: absolute;
  left: 2px;
  top: 2px;
}
</style>